import { TextInput } from 'gu-ui-kit'
import React from 'react'
import MaskedInput from 'react-text-mask'
import { useSelector } from 'react-redux'

const renderMaskedInput = ({
  input,
  meta: { touched, error, submitting, form },
  pipe = null,
  mask = (value) => Array(value.length).fill(/[\d.]/),
  placeholderChar = '\u2000',
  t = (val) => val,
  helperText = null,
  hidden = false,
  placeholder = '',
  fullWidth = false,
  type = 'text',
  label = '',
  disabled = false,
  required: requiredProp,
  ...rest
}) => {
  const requiredFromSchema = useSelector(
    (state) => state['forms/meta']?.[form]?.[input.name] ?? false,
  )
  const required = requiredProp ?? requiredFromSchema

  return (
    <MaskedInput
      mask={mask}
      pipe={pipe}
      placeholder={placeholder}
      placeholderChar={placeholderChar}
      disabled={submitting || disabled}
      type={type}
      fullWidth={fullWidth}
      required={required}
      error={touched && error}
      hidden={hidden}
      helperText={touched && error ? t(error) : helperText}
      label={label}
      {...input}
      {...rest}
      render={(ref, props) => <TextInput ref={ref} {...props} />}
    />
  )
}

export default renderMaskedInput
